import { CustomHamper } from 'components/desktop/organisms';

export const CustomHamperDesktopSlot = () => {
  return <CustomHamper />;
};
